export function transformComment(input) {
    input = input.replace(/<!--(.*?)-->/gm, '$1');
    if (input.startsWith('video_in_body-youtube')) {
        input = input.replace('video_in_body-youtube-watch?v=', '').replace('video_in_body-youtube-', '');
        return `<iframe src="https://www.youtube.com/embed/${input}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    }
    return input;
}
